<template>
  <section class="content">
    <div v-if="!$gate.isType(['admin', 'editor'])">
        <not-found></not-found>
    </div>
    <div v-else class="container-fluid">
      <loader v-if="loading" :type="'table'"/>
      <div v-else>
        <div class="row">
            <div class="col-12">
              <h1>{{translate('messages.user_monitor')}}</h1>
            </div>
          </div>
          
        <div class="row mt-4">
            <div class="col-12">
                <div class="card card-widget widget-user-2">
                    <div class="widget-user-header">
                        <div class="widget-user-image">
                            <img class="img-circle elevation-2" :src="user.photo" alt="User Avatar">
                        </div>
                        <!-- /.widget-user-image -->
                        <h3 class="widget-user-username">{{user.name}}</h3>
                        <h5 class="widget-user-desc">
                            <div>{{user.type}}</div>
                            <div><i class="fas fa-envelope fa-fw"></i> {{user.email}}</div>
                            <div v-if="user.settings.mobile_phone">
                                <i class="fab fa-whatsapp fa-fw"></i> {{user.settings.mobile_phone}}
                                <span class="ml-2">
                                    (
                                    <span v-if="user.settings.mobile_phone_status == 'verificated'" class="text-success">{{translate('messages.verificated')}}</span>
                                    <span v-else class="text-warning">{{translate('messages.pending')}}</span>
                                    )
                                </span>
                                <div>
                                    <button v-if="user.settings.mobile_phone_status == 'verificated'" type="button" class="btn btn-sm btn-default" @click="setMobilePhoneVerification('pending')">
                                        {{translate('messages.remove_verification')}}
                                    </button>
                                
                                    <button v-else type="button" class="btn btn-sm btn-default" @click="setMobilePhoneVerification('verificated')">
                                        {{translate('messages.verificate')}}
                                    </button>
                                </div>
                            </div>
                            <div v-else>
                                <i class="fab fa-whatsapp fa-fw"></i> <i>{{translate('messages.missing_mobile_phone')}}</i>
                            </div>
                            <div class="mt-3">
                                {{translate('messages.interests')}}: <br>
                                <span v-if="user_interests">{{user_interests}}</span>
                                <small v-else>-{{translate('messages.no_data')}}-</small>
                            </div>
                        </h5>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-sm-12 col-md-6">
                <div class="card user-data">
                    <div class="card-header bg-black">
                        <h3 class="card-title">{{translate('messages.markers')}}</h3>
                    </div>
                    <!-- /.card-header -->
                    <div class="card-body p-0">
                        <table class="table table-striped">
                            <tbody>
                                <tr v-for="marker in user.markers" :key="'marker-'+marker.id">
                                    <td><a :href="marker.url" target="_BLANK">{{marker.name}}</a></td>
                                </tr>
                            </tbody>
                            <div v-if="user.markers && !user.markers.length" class="text-center"><small>-{{translate('messages.no_data')}}-</small></div>
                        </table>
                    </div>
                    <!-- /.card-body -->
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-6">
                <div class="card user-data">
                    <div class="card-header bg-black">
                        <h3 class="card-title">{{translate('messages.feeds')}}</h3>
                    </div>
                    <!-- /.card-header -->
                    <div class="card-body p-0">
                        <table class="table table-striped">
                            <tbody>
                                <tr v-for="feed in user.feeds" :key="'feed-'+feed.id">
                                    <td><i v-if="feed.active_submission" class="fab fa-whatsapp" v-tooltip:bottom="translate('messages.activate_submission')" data-toggle="tooltip"></i> {{feed.keyword}}</td>
                                </tr>
                            </tbody>
                            <div v-if="user.feeds && !user.feeds.length" class="text-center"><small>-{{translate('messages.no_data')}}-</small></div>
                        </table>
                    </div>
                    <!-- /.card-body -->
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-6">
                <div class="card user-data">
                    <div class="card-header bg-black">
                        <h3 class="card-title">{{translate('messages.social_searchers')}}</h3>
                    </div>
                    <!-- /.card-header -->
                    <div class="card-body p-0">
                        <div class="px-4" v-if="$gate.hasFeaturePermission('social_searchers', user)">
                            <form class="mt-3" @submit.prevent="updateSocialSearches()">
                                <div class="form-group">
                                    <input type="number" class="form-control d-inline mr-2" style="width: 5rem; font-size: 1.2rem;" v-model="social_searches_form.remaining_searches" :disabled="!$gate.isType('admin')"> <span>{{translate('messages.remaining_searches')}}</span>
                                </div>
                                <div class="form-group" v-if="$gate.isType('admin')">
                                    <button type="submit" class="btn btn-primary" :disabled="social_searches_form.remaining_searches==user.features_usage.social_searches.remaining">{{translate('messages.update')}} {{translate('messages.remaining_searches')}}</button>
                                </div>
                            </form>
                        </div>
                        <table class="table table-striped">
                            <tbody>
                                <tr v-for="social_searcher in user.social_searchers" :key="'social_searcher-'+social_searcher.id">
                                    <td>{{social_searcher.keyword}}</td>
                                </tr>
                            </tbody>
                            <div v-if="user.social_searchers && !user.social_searchers.length" class="text-center"><small>-{{translate('messages.no_data')}}-</small></div>
                        </table>
                    </div>
                    <!-- /.card-body -->
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-6">
                <div class="card user-data">
                    <div class="card-header bg-black">
                        <h3 class="card-title">{{translate('messages.chamber_searches')}}</h3>
                    </div>
                    <!-- /.card-header -->
                    <div class="card-body p-0">
                        <table class="table table-striped">
                            <tbody>
                                <tr v-for="chamber_search in user.chamber_searches" :key="'chamber_search-'+chamber_search.id">
                                    <td>{{chamber_search.keyword}} - {{translate('messages.'+chamber_search.type+'s')}}</td>
                                </tr>
                            </tbody>
                            <div v-if="user.chamber_searches && !user.chamber_searches.length" class="text-center"><small>-{{translate('messages.no_data')}}-</small></div>
                        </table>
                    </div>
                    <!-- /.card-body -->
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-6">
                <div class="card user-data">
                    <div class="card-header bg-black">
                        <h3 class="card-title">{{translate('messages.social_timelines')}}</h3>
                    </div>
                    <!-- /.card-header -->
                    
                    <div class="card-body p-0">
                        <table class="table table-striped">
                            <tbody>
                                <tr v-for="social_timeline in user.social_timelines" :key="'social_timeline-'+social_timeline.id">
                                    <td><a :href="social_timeline.url" target="_BLANK">{{social_timeline.url}}</a></td>
                                </tr>
                            </tbody>
                            <div v-if="user.social_timelines && !user.social_timelines.length" class="text-center"><small>-{{translate('messages.no_data')}}-</small></div>
                        </table>
                    </div>
                    <!-- /.card-body -->
                </div>
            </div>
        </div>
                    
          <div class="row" v-if="$gate.hasFeaturePermission('personal_news', user)">

            <div class="col-12">
          
              <div class="card">
                <div class="card-header bg-black">
                  <h3 class="card-title">{{translate('messages.personal_news')}}</h3>

                  <div class="card-tools">
                    <button type="button" class="btn btn-sm btn-primary" @click="newModal">
                        <i class="fa fa-plus-square"></i>
                        {{translate('messages.add_new_a')}}
                    </button>
                  </div>
                </div>
                <!-- /.card-header -->
                <div class="card-body table-responsive p-0">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th>{{translate('messages.content')}}</th>
                        <th>{{translate('messages.date')}}</th>
                        <th>{{translate('messages.actions')}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="personal_new in personal_news.data" :key="'personal_new-'+personal_new.id">
                        <td>{{personal_new.content | stripHTML | strLimit(600)}}</td>
                        <td>{{personal_new.created_at | localDate}}</td>
                        <td>
                            
                          <span v-if="personal_new.sent" class="btn btn-link mb-1" v-tooltip:bottom="translate('messages.personal_new')+' '+translate('messages.sent_a')" data-toggle="tooltip">
                              <i class="fas fa-check"></i>
                          </span>
                          <span v-else-if="!user.settings.mobile_phone" class="btn btn-link mb-1" v-tooltip:bottom="translate('messages.missing_mobile_phone')" data-toggle="tooltip">
                              <i class="fas fa-exclamation-triangle"></i>
                          </span>
                           <a v-else @click="sendPersonalNew(personal_new.id)" class="btn btn-link mb-1" v-tooltip:bottom="translate('messages.send')" data-toggle="tooltip">
                              <i class="fas fa-paper-plane"></i>
                          </a>

                          <a @click="editModal(personal_new)" class="btn btn-link mb-1" v-tooltip:bottom="translate('messages.update')" data-toggle="tooltip">
                              <i class="fa fa-edit blue"></i>
                          </a>
                          
                          <a @click="deletePersonalNew(personal_new.id)" class="btn btn-link mb-1" v-tooltip:bottom="translate('messages.delete')" data-toggle="tooltip">
                              <i class="fa fa-trash red"></i>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div v-if="personal_news.data && !personal_news.data.length" class="text-center"><small>-{{translate('messages.no_data')}}-</small></div>
                </div>
                <!-- /.card-body -->
                <div class="card-footer">
                    <pagination :data="personal_news" @pagination-change-page="loadPersonalNews"></pagination>
                </div>
              </div>
              <!-- /.card -->
            </div>
          </div>
      </div>

        <!-- Modal -->
        <div class="modal fade full-modal" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <form @submit.prevent="editmode ? updatePersonalNew() : createPersonalNew()">
                        <div class="card wysiwyg shadow-none m-0 maximized-card">
                            <div class="card-header bg-black">
                                <h3 class="card-title py-1 my-0" v-show="!editmode">{{translate('messages.create_personal_new')}}</h3>
                                <h3 class="card-title py-1 my-0" v-show="editmode">{{translate('messages.update_personal_new')}}</h3>
                                
                                <div class="card-tools">
                                    <button type="button" class="btn btn-tool" data-dismiss="modal" v-tooltip:bottom="translate('messages.close')" data-toggle="tooltip">
                                        <i class="fas fa-times"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="card-body p-0">
                                <input v-model="form.user_id" type="hidden" name="user_id">
                                <vue-editor v-model="form.content" :editorOptions="editor_settings" />
                            </div>
                            <div class="card-footer text-right">
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">{{translate('messages.close')}}</button>
                                <button v-show="editmode" type="submit" class="btn btn-success">{{translate('messages.update')}}</button>
                                <button v-show="!editmode" type="submit" class="btn btn-primary">{{translate('messages.create')}}</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
  </section>
</template>

<script>

    export default {
        data () {
            return {
                editmode: false,
                personal_news : {},
                personal_news_page : 1,
                form: new Form({
                    id : '',
                    content: '',
                    user_id: '',
                }),
                loading : true,
                user : {},
                user_interests : '',
                editor_settings: {
                    modules: {
                        imageDrop: true,
                        imageResize: {},
                        imageCompress: {
                            quality: 0.7, // default
                            maxWidth: 1000, // default
                            maxHeight: 1000, // default
                            imageType: 'image/jpeg', // default
                            debug: false, // default
                        }
                    }
                },
                resize_timeout: null,
                saved : true,
                social_searches_form: new Form({
                    remaining_searches : 0
                }),
            }
        },
        methods: {
          loadUserMonitor(){
                this.$Progress.start();
                axios.get("/api/user/monitor/"+this.$route.params.user_id).then(({ data }) => {
                    this.user = data.data;
                    this.user_interests = this.user.settings.interests ?? '';
                    this.loading = false;
                    this.social_searches_form.update({remaining_searches: this.user.features_usage.social_searches.remaining});
                    this.loadPersonalNews();
                    this.$Progress.finish();
                });
          },
          loadPersonalNews(page = 1){
            this.$Progress.start();
            this.personal_news_page = page;
            axios.get("/api/user/personalNews/"+this.$route.params.user_id + "?page=" + page).then(({ data }) => {
                this.personal_news = data.data;
                if(!this.personal_news.data.length && this.personal_news_page > 1){
                    this.loadPersonalNews(this.personal_news_page - 1);
                }
                this.$Progress.finish();
            });
          },
          editModal(personal_new){
              this.resizeEditor();
              this.editmode = true;
              this.form.reset();
              $('#addNew').modal('show');
              this.form.fill(personal_new);
          },
          newModal(){
              this.resizeEditor();
              this.editmode = false;
              this.form.reset();
              $('#addNew').modal('show');
          },
          createPersonalNew(){
              this.$Progress.start();
              this.saved = true;
              this.form.update({_method:'post', user_id: this.$route.params.user_id});
              this.form.post('/api/personalNew')
              .then((response)=>{
                $('#addNew').modal('hide');

                Toast.fire({
                      icon: 'success',
                      title: response.data.message
                  });
                this.$Progress.finish();
                this.loadPersonalNews(this.personal_news_page);
              })
              .catch((error)=>{
                let error_obj = JSON.parse(error.request.response);
                let error_title = typeof(error_obj.message) !== null && error.request.status < 500 ? error_obj.message : window.translate('messages.error_ocurred');
                if(error_title=='The given data was invalid.') error_title = window.translate('messages.invalid_data');
                Toast.fire({
                    icon: 'error',
                    title: error_title
                });
                this.$Progress.fail();
              })
          },
          updatePersonalNew(){
              this.$Progress.start();
              this.saved = true;
              this.form.update({_method:'put', user_id: this.$route.params.user_id});
              this.form.post('/api/personalNew/'+this.form.id)
              .then((response) => {
                  // success
                  $('#addNew').modal('hide');
                  Toast.fire({
                    icon: 'success',
                    title: response.data.message
                  });
                  this.$Progress.finish();
                      //  Fire.$emit('AfterCreate');
                  this.loadPersonalNews(this.personal_news_page);
              })
              .catch((error) => {
                let error_obj = JSON.parse(error.request.response);
                let error_title = typeof(error_obj.message) !== null && error.request.status < 500 ? error_obj.message : window.translate('messages.error_ocurred');
                if(error_title=='The given data was invalid.') error_title = window.translate('messages.invalid_data');
                Toast.fire({
                    icon: 'error',
                    title: error_title
                });
                this.$Progress.fail();
              });

          },
          deletePersonalNew(id){
            Swal.fire({
              title: window.translate('messages.are_you_sure'),
              text: window.translate('messages.no_revert'),
              showCancelButton: true,
              confirmButtonColor: '#d33',
              cancelButtonColor: '#3085d6',
              cancelButtonText: window.translate('messages.cancel'),
              confirmButtonText: window.translate('messages.delete_confirm')
              })
              .then((result) => {
                // Send request to the server
                if (result.value) {
                  this.$Progress.start();
                  this.form.delete('/api/personalNew/'+id).then((response)=>{
                    this.$Progress.finish();
                    Toast.fire({
                        icon: 'success',
                        title: response.data.message
                    });
                    // Fire.$emit('AfterCreate');
                    this.loadPersonalNews(this.personal_news_page);
                  }).catch((error)=> {
                    let error_obj = JSON.parse(error.request.response);
                    let error_title = typeof(error_obj.message) !== null && error.request.status < 500 ? error_obj.message : window.translate('messages.error_ocurred');
                    if(error_title=='The given data was invalid.') error_title = window.translate('messages.invalid_data');
                    Toast.fire({
                      icon: 'error',
                      title: error_title
                    });
                    this.$Progress.fail();
                  });
                }
            });
          },
          sendPersonalNew(id){
            Swal.fire({
              title: window.translate('messages.are_you_sure'),
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              cancelButtonText: window.translate('messages.cancel'),
              confirmButtonText: window.translate('messages.send')
              })
              .then((result) => {
                // Send request to the server
                if (result.value) {
                  this.$Progress.start();
                  axios.get("/api/personalNew/send/"+id).then((data) => {
                    this.$Progress.finish();
                    Toast.fire({
                        icon: 'success',
                        title: data.data.message
                    });
                    // Fire.$emit('AfterCreate');
                    this.loadPersonalNews(this.personal_news_page);
                  }).catch((error)=> {
                    let error_obj = JSON.parse(error.request.response);
                    let error_title = typeof(error_obj.message) !== null && error.request.status < 500 ? error_obj.message : window.translate('messages.error_ocurred');
                    if(error_title=='The given data was invalid.') error_title = window.translate('messages.invalid_data');
                    Toast.fire({
                      icon: 'error',
                      title: error_title
                    });
                    this.$Progress.fail();
                  });
                }
            });
          },
            resizeEditor(){
                clearTimeout(this.resize_timeout);
                this.resize_timeout = setTimeout(function(){
                    var height = parseInt($('.ql-toolbar').outerHeight()) + 15;
                    $('.ql-editor').css('padding-top', height+'px');
                }, 200);
            },
            confirmUnsaved(e){
                if(this.saved) return;
                e.preventDefault();
                e.stopImmediatePropagation();
                Swal.fire({
                    title: window.translate('messages.unsaved_changes'),
                    text: window.translate('messages.are_you_sure_exit'),
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    cancelButtonText: window.translate('messages.cancel'),
                    confirmButtonText: window.translate('messages.exit_confirm')
                })
                .then((result) => {
                    // Send request to the server
                    if (result.value) {
                        this.saved = true;
                        $('#addNew').modal('hide');
                    }
                })
            },
            updateSocialSearches(){
                this.$Progress.start();
                this.social_searches_form.update({_method:'put'});
                this.social_searches_form.post('/api/user/socialSearches/'+this.$route.params.user_id)
                .then((response) => {
                    // success
                    Toast.fire({
                        icon: 'success',
                        title: response.data.message
                    });
                    this.$Progress.finish();
                    this.loadUserMonitor();
                })
                .catch((error) => {
                    let error_obj = JSON.parse(error.request.response);
                    let error_title = typeof(error_obj.message) !== null && error.request.status < 500 ? error_obj.message : window.translate('messages.error_ocurred');
                    if(error_title=='The given data was invalid.') error_title = window.translate('messages.invalid_data');
                    Toast.fire({
                        icon: 'error',
                        title: error_title
                    });
                    this.$Progress.fail();
                    this.loadUserMonitor();
                });
            },
            setMobilePhoneVerification(status){
                this.$Progress.start();
                axios.post('/api/user/setMobilePhoneVerification/'+this.$route.params.user_id, {status:status}).then(({ data }) => {
                    this.$Progress.finish();
                    Toast.fire({
                        icon: 'success',
                        title: data.message
                    });
                    this.loadUserMonitor();
                }).catch((error) => {
                    let error_obj = JSON.parse(error.request.response);
                    let error_title = typeof(error_obj.message) !== null && error.request.status < 500 ? error_obj.message : window.translate('messages.error_ocurred');
                    if(error_title=='The given data was invalid.') error_title = window.translate('messages.invalid_data');
                    Toast.fire({
                        icon: 'error',
                        title: error_title
                    });
                    this.loadUserMonitor();
                    this.$Progress.fail();
                });
            }
        },
        mounted() {
            var vm = this;
            $('#addNew').on('hide.bs.modal', function(e){
                vm.confirmUnsaved(e);
            });
            $('.ql-editor').on('keyup', function(){
                if(!vm.saved) return;
                vm.saved=false;
            });
            window.addEventListener("resize", this.resizeEditor);
        },
        created() {
            this.loadUserMonitor();
        },
        beforeDestroy() {
            window.removeEventListener("resize", this.resizeEditor);
        }
    }
</script>
